import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["use", "inlineSize", "blockSize", "children"];
import { View } from 'foundations-components/components/View';
import styled from 'styled-components';
import { SkeletonGradient } from './SkeletonGradient';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DisplayOverGradient = styled.div.withConfig({
  displayName: "SkeletonView__DisplayOverGradient",
  componentId: "sc-1czhmn7-0"
})(["position:absolute;z-index:1;inline-size:100%;block-size:100%;"]);
export const SkeletonView = _ref => {
  let {
      use = 'default',
      inlineSize = '40px',
      blockSize = '15px',
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsxs(View, Object.assign({
    overflow: "hidden",
    inlineSize: inlineSize,
    blockSize: blockSize,
    "data-loading": "true",
    position: "relative"
  }, props, {
    children: [/*#__PURE__*/_jsx(DisplayOverGradient, {
      children: children
    }), /*#__PURE__*/_jsx(SkeletonGradient, {
      use: use
    })]
  }));
};
SkeletonView.displayName = 'SkeletonView';
export default SkeletonView;